import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PopularCoursesComponent} from './popular-courses.component';
import {AddPopularCoursesComponent} from './add-popular-courses/add-popular-courses.component';
import {PopularCourseInfoComponent} from './popular-course-info/popular-course-info.component';
import {PopularCoursesMarketingTagComponent} from './popular-courses-marketing-tag/popular-courses-marketing-tag.component';
import {PopularCourseDetailShellComponent} from './popular-course-detail-shell/popular-course-detail-shell.component';
import {PopularCourseOverviewComponent} from './popular-course-overview/popular-course-overview.component';
import {PopularCourseEligibilityDurationComponent} from './popular-course-eligibility-duration/popular-course-eligibility-duration.component';
import {PopularCourseFeeStructureComponent} from './popular-course-fee-structure/popular-course-fee-structure.component';
import {PopularCourseTopUniversitiesComponent} from './popular-course-top-universities/popular-course-top-universities.component';
import {PopularCourseSubjectSyllabusComponent} from './popular-course-subject-syllabus/popular-course-subject-syllabus.component';
import {PopularCourseFaqComponent} from './popular-course-faq/popular-course-faq.component';
import {PopularCourseAdmissionProcessComponent} from './popular-course-admission-process/popular-course-admission-process.component';
import {PopularCourseBenefitsComponent} from './popular-course-benefits/popular-course-benefits.component';
import {PopularCourseCareerComponent} from './popular-course-career/popular-course-career.component';
import {PopularCourseWhyUsComponent} from './popular-course-why-us/popular-course-why-us.component';

const routes: Routes = [
    {
        path: 'popular-courses',
        component: PopularCoursesComponent,
        data: {animation: 'popular-courses'}
    },
    {
        path: 'popular-courses/add',
        component: AddPopularCoursesComponent,
        data: {animation: 'popular-courses/add'}
    },
    {
        path: 'popular-course-info/:id',
        component: PopularCourseInfoComponent,
        data: {animation: 'popular-courses-info'}
    },
    {
        path: 'popular-course-marketing-tag/:id',
        component: PopularCoursesMarketingTagComponent,
        data: {animation: 'popular-courses-marketing-tag'}
    },
    {
        path: 'popular-course/:id',
        component: PopularCourseDetailShellComponent,
        data: {animation: 'popular-course'},
        children: [
            {path: 'overview', component: PopularCourseOverviewComponent},
            {path: 'eligibility-duration', component: PopularCourseEligibilityDurationComponent},
            {path: 'fee-structure', component: PopularCourseFeeStructureComponent},
            {path: 'top-universities', component: PopularCourseTopUniversitiesComponent},
            {path: 'admission-process', component: PopularCourseAdmissionProcessComponent},
            {path: 'subject-syllabus', component: PopularCourseSubjectSyllabusComponent},
            {path: 'benefits', component: PopularCourseBenefitsComponent},
            {path: 'career', component: PopularCourseCareerComponent},
            {path: 'why-us', component: PopularCourseWhyUsComponent},
            {path: 'faqs', component: PopularCourseFaqComponent}
        ]
    }

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PopularCoursesRoutingModule {
}
